// extracted by mini-css-extract-plugin
export var top_visual = "style-module--top_visual--639e3";
export var top_visual_decoration = "style-module--top_visual_decoration--e80ab";
export var top_visual_media = "style-module--top_visual_media--1d1c2";
export var top_visual_title = "style-module--top_visual_title--0563a";